export default function formatDistance(distance) {
  let value = parseFloat(distance).toFixed(2);
  let unit = 'kilometer';
  if(value < 1) {
    unit = 'meter';
    value = value*1000;
  }else{
    value = parseInt(value);
  }


  return new Intl.NumberFormat("de-CH", {
    style: "unit",
    unit: unit,
    unitDisplay: "short",
  }).format(value);
}
